import { Injectable } from '@angular/core';
import { ApiHomologationService } from './api-homologation.service';
import { HomeService } from './home.service';
import { BehaviorSubject, catchError, forkJoin, map, of } from 'rxjs';
import { Order } from '../interfaces/order.interface';
import { NotificationService } from './notification.service';

@Injectable({
  providedIn: 'root'
})
export class OrderHistoryService {

  private historyOrders = new BehaviorSubject<any[]>([]);
  historyOrders$ = this.historyOrders.asObservable();

  private currentStateFilter = new BehaviorSubject<number>(1);
  currentStateFilter$ = this.currentStateFilter.asObservable();

  private isLoading = new BehaviorSubject<boolean>(false);
  isLoading$ = this.isLoading.asObservable();

  constructor(
    private _apiHomologationService: ApiHomologationService,
    private _homeService: HomeService,
    private _notificationService: NotificationService
  ) {

  }

  setLoadingStatus(status: boolean) {
    this.isLoading.next(status);
  }

  setStateFilter(state: number) {
    this.currentStateFilter.next(state);
  }

  clearHistoryOrders() {
    this.historyOrders.next([]);
  }

  setHistoryOrders(data: any) {

    try {

      const groupedData = data.data.data.reduce((result: { [key: string]: any[] }, item: any) => {
        const key = item.externalOrderNumber;
        if (!result[key]) {
          result[key] = [];
        }
        result[key].push(item);
        return result;
      }, {});

      let dataFilteredGrouped: any = {};

      const observables = Object.keys(groupedData).map((key) => {
        const dataFiltered = ApiHomologationService.associateServicesWithProducts(groupedData[key]);
        let id = 0;

        const imageRequests = dataFiltered.map((x) => {
          id++;
          x.id = id;

          return this._homeService.getProductImageBySku(x.sku).pipe(
            map((response: any) => {
              const results = response;
              if (results) {
                x.imageSku = results.base64;
                x.descSKU = ApiHomologationService.capitalizeFirstLetter(x.descSKU)! + " - " + x.sku;
                if (results.name != null && results.name != "null" && results.name != "") {
                  x.descSKU = results.name;
                }
              }

              return x;
            }),
            catchError(error => {
              console.log(`[${x.sku}] ERROR loading image "${x.sku}"`);
              return of(x);
            })
          );
        });

        return forkJoin(imageRequests).pipe(
          map((updatedData) => {
            let dataTemp: any[] = [];
            updatedData.forEach(x => {

              x.quantity = x.quantity | 1;
              let uniqueTrackingNumbers: string[] = [];

              if (x.historyStatus) {
                const trackingLatestDates = new Map<string, number>();
                x.historyStatus.forEach(item => {
                  if (item.trackingNumber && item.trackingNumber.trim() !== '') {
                    const time = item.historyDate ? new Date(item.historyDate).getTime() : 0;
                    const existingTime = trackingLatestDates.get(item.trackingNumber) || 0;
                    if (time >= existingTime) {
                      trackingLatestDates.set(item.trackingNumber, time);
                    }
                  }
                });

                let allTrackings = Array.from(trackingLatestDates.keys())
                  .sort((a, b) => (trackingLatestDates.get(b) || 0) - (trackingLatestDates.get(a) || 0));

                const validTrackings = allTrackings.filter(t => !t.includes('-.') && !t.endsWith('-'));
                uniqueTrackingNumbers = validTrackings.length > 0 ? validTrackings : allTrackings;
              }

              for (var i = 0; i < x.quantity; i++) {
                let trackingNumber = null;
                if (uniqueTrackingNumbers.length > 1) {
                  if (uniqueTrackingNumbers[i] != undefined) {
                    trackingNumber = uniqueTrackingNumbers[i];
                  } else {
                    trackingNumber = "NN";
                  }
                } else if (uniqueTrackingNumbers.length === 1 && x.quantity === 1) {
                  trackingNumber = uniqueTrackingNumbers[0];
                }
                dataTemp.push(ApiHomologationService.mapToOrder(x, trackingNumber!));
              }
            });
            dataFilteredGrouped[key] = dataTemp;
          })
        );
      });

      forkJoin(observables).subscribe(() => {
        this.historyOrders.next(dataFilteredGrouped);
        if (typeof window !== 'undefined' && window.sessionStorage) {
          sessionStorage.removeItem("orderHistoryData");
          sessionStorage.setItem("orderHistoryData", JSON.stringify(dataFilteredGrouped));
        }
        //console.log("Data saved to localStorage:", dataFilteredGrouped);
        this.getHistoryOrders();
      });

    } catch (error) {
      console.error('Error al cargar los datos:', error);
      this._notificationService.showError('Ocurrió un error al cargar los datos.');
    }
  }




  getHistoryOrders() {
    if (this.historyOrders.value.length == 0) {
      if (typeof window !== 'undefined' && window.sessionStorage) {
        const storedData = sessionStorage.getItem('orderHistoryData');
        if (storedData) {
          this.historyOrders.next(JSON.parse(storedData));
        }
      }
    }
    return this.historyOrders;
  }


}
